import React from 'react';
import { twMerge } from 'tailwind-merge';

const PageTitleContainer = ({ children, className }) => {
  return <div className={twMerge('flex w-full justify-between items-center mb-4 lg:mb-8', className)}>{children}</div>;
};

export default PageTitleContainer;
